import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import LegacySelect2, {LegacySelect2ChangeEvent} from 'ui-library/LegacySelect2';

interface DataTableColumnPickerProps {
  allColumns: Array<{id: number; name: string}>;
  selectedColumnId: number | null;
  onSelectedColumnChange: (selectedColumn: {id: number; name: string}) => void;
}

export class DataTableColumnPicker extends React.Component<DataTableColumnPickerProps> {
  static propTypes = {
    allColumns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
    selectedColumnId: PropTypes.number,
    onSelectedColumnChange: PropTypes.func.isRequired,
  };

  _handleColumnSelected = (e: LegacySelect2ChangeEvent): void => {
    this.props.onSelectedColumnChange(_.findWhere(this.props.allColumns, {id: e.val})!);
  };

  render(): JSX.Element {
    return (
      <FormGroup>
        <Label className="u-text-uppercase">{MODEL_NAMES.Result_Table} Field</Label>
        <LegacySelect2
          placeholder="Select a column"
          options={this.props.allColumns.map((column) => ({
            id: column.id,
            text: column.name,
          }))}
          value={this.props.selectedColumnId}
          onChange={this._handleColumnSelected}
        />
      </FormGroup>
    );
  }
}

export default DataTableColumnPicker;
